// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"Input_inputBox__2aZo1","space":"Input_space__2e0gS","input":"Input_input__3rPb3"};